import React, { useEffect } from "react";
import { GetStaticPaths, GetStaticProps } from "next";
import fetchUtil from "../../utils/fetchUtil";
import ErrorComponent from "../../components/ErrorComponent";
import FranchiseeComponent from "../../components/StudyAbroad/FranchiseeComponent";
import { MetaTagsComp } from "../../components/MetaTagsComp";
import { CACHE_REVALIDATE_24H } from "../../utils/constants";
import PartnerCountry from "../../components/PartnerCountry/PartnerCountry";

const isEmptyData = (data: any) => !data || data.length === 0;

const PartnerCountryPage: React.FC = (props: any) => {
  useEffect(() => {
    const customStyle = document.documentElement.style;
    customStyle.setProperty("--navbar-color", "#6C48F0");
    customStyle.setProperty("--navbar-menu-color", "#ffffff");
  }, []);

  if (props.mode === "oldUI") {
    if (isEmptyData(props.pageData)) {
      return <ErrorComponent />;
    }

    return <FranchiseeComponent eventData={props.pageData[0]} countryTeamData={props?.countryTeamData} />;
  }

  if (isEmptyData(props.partnerCountryData)) {
    return <ErrorComponent />;
  }

  const meta = props.partnerCountryData[0]?.meta;

  return (
    <>
      {meta && <MetaTagsComp {...meta} canonicalUrl={`${process.env.NEXT_PUBLIC_BASE_URL}/partners/${props.slug}`} />}
      <PartnerCountry partnerCountryData={props.partnerCountryData[0]} />
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: "blocking" };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const slug = context.params?.slug as string;

  try {
    const [pageData, countryTeamData, partnerCountryData] = await Promise.all([
      fetchUtil(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/franchisee-pages?slug=${slug}&categoryType=partners&_locale=${context.locale}`,
        "GET",
        {},
        "",
        false,
      ) as any,
      fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/office-countries?PartnerSlug=${slug}&_locale=${context.locale}`, "GET", {}, "", false),
      fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/partner-country-pages?slug=${slug}`, "GET", {}, "", false),
    ]);

    const isOldUI = pageData?.[0]?.newUI === false;

    if (isOldUI ? isEmptyData(pageData) : isEmptyData(partnerCountryData)) {
      return { notFound: true, revalidate: CACHE_REVALIDATE_24H };
    }

    return {
      props: {
        pageData,
        countryTeamData,
        partnerCountryData,
        slug,
        mode: isOldUI ? "oldUI" : "newUI",
      },
      revalidate: CACHE_REVALIDATE_24H,
    };
  } catch (err) {
    return { notFound: true, revalidate: 60 };
  }
};

export default PartnerCountryPage;
